import { Inject, Injectable, Optional, Type } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, ButtonsComponent, CartSalesStepComponent, CartService, CartTotalStepComponent, CheckoutStepComponent, GungFlowService, NavigationConfig, QuantityValidationStepComponent, RemoveBlockedProductsStepComponent } from 'gung-standard';
import { AssignOrderRowsJeevesComponent, JeevesCheckoutConfigService, JeevesCustomerConfigService, OrderTermsJeevesComponent, SummarizeOrderJeevesComponent } from 'gung-standard-jeeves';
import { forkJoin, Observable, first, map } from 'rxjs';
import { CarLinerButtonsComponent } from '../components/car-liner-buttons/car-liner-buttons.component';
import { CarLinerDeliveryLocationsJeevesComponent } from '../components/car-liner-delivery-locations-jeeves/car-liner-delivery-locations-jeeves.component';
import { CarLinerRemoveBlockedProductsStepComponent } from '../components/car-liner-remove-blocked-products-step/car-liner-remove-blocked-products-step.component';

@Injectable({
  providedIn: 'root'
})
export class CarLinerCheckoutConfigService extends JeevesCheckoutConfigService {
  constructor(
    router: Router,
    protected authService: AuthService,
    protected gungFlowService: GungFlowService,
    protected jeevesCustomerConfigService: JeevesCustomerConfigService,
    protected cartService: CartService,
    @Optional()
    @Inject('environment')
    protected environment: NavigationConfig
  ) {
    super(router, authService, gungFlowService, jeevesCustomerConfigService, environment);
  }

  getButtonsComponent(): Type<ButtonsComponent> {
    return CarLinerButtonsComponent;
  }

  standardPreSteps(): Observable<Type<CheckoutStepComponent>[]> {
    return super.standardPreSteps().pipe(
      // Product 46607-03 is a virtual custom order line (freight/fee) added by sales/admin via the cart "+" button.
      // The backend marks it as blocked (products-blocked-flow-multi) because it has no catalog entry.
      // We swap in CarLinerRemoveBlockedProductsStepComponent which runs the same logic but excludes 46607-03,
      // so the custom row survives checkout without being silently removed.
      map(steps =>
        steps.map(step =>
          step === RemoveBlockedProductsStepComponent ? CarLinerRemoveBlockedProductsStepComponent : step
        )
      )
    );
  }
  protected getMainProcessStepsByRole(): Observable<Type<CheckoutStepComponent>[]> {
    return forkJoin([
      this.authService.getRoles().pipe(first()),
      this.gungFlowService.getSelectedFlow().pipe(first())
    ]).pipe(
      first(),
      map(([roles, flow]) => {
        const steps = [];
        const filteredRoles = roles.filter(role => role.toUpperCase() === 'ADMIN' || role.toUpperCase() === 'SALES');
        const isSalesOrAdmin = filteredRoles.length > 0;
        const isUserDistributor = roles.indexOf('USER') > -1 && roles.indexOf('DISTRIBUTOR') > -1;
        if (!isSalesOrAdmin) {
          steps.push(CartTotalStepComponent);
          steps.push(AssignOrderRowsJeevesComponent);
          steps.push(CarLinerDeliveryLocationsJeevesComponent);
          return steps;
        }
        if (isSalesOrAdmin) {
          steps.push(CartSalesStepComponent);
        } else {
          steps.push(CartTotalStepComponent);
        }
        steps.push(AssignOrderRowsJeevesComponent);

        // steps.push(DeliveryLocationsJeevesComponent);
        steps.push(CarLinerDeliveryLocationsJeevesComponent);

        // if (isSalesOrAdmin) {
        //   steps.push(OrderTermsJeevesComponent);
        // }

        // steps.push(SummarizeOrderJeevesComponent);

        if (flow.requireAvailability) {
          steps.push(QuantityValidationStepComponent);
        }

        return steps;
      })
    );
  }
}
